// extracted by mini-css-extract-plugin
export var conference = "conference_T99XeA_Ytk3eu4P20oCf";
export var conferenceMain = "conference__main_mNiZ300dqoYUAnC5sTIl";
export var conferenceSidebar = "conference__sidebar_pcvkojrXfrUg6k7PK64p";
export var conferenceWrapper = "conference__wrapper_ophlSwQ3UsWAWK7J9qW2";